import { etagInterceptor } from "./interceptors/etagInterceptor";
import { statusInterceptor } from "./interceptors/statusInterceptor";
import { mockDataInterceptor } from "./interceptors/mockDataInterceptor";
import { shimmer } from "./interceptors/shimmer";

export default function httpConfig($httpProvider, config) {
	$httpProvider.interceptors.push(etagInterceptor, statusInterceptor, shimmer);
	if(["dev", "beta", "local", "staging"].indexOf(config.environment) > -1)
		$httpProvider.interceptors.push(mockDataInterceptor);
}
